import { type SxProps, type Theme } from "@mui/material";

import { AppSkeletonBlock } from "./AppSkeletonBlock";

interface AppSkeletonCircleProps {
  size: number | string;
  sx?: SxProps<Theme>;
}

export function AppSkeletonCircle(props: AppSkeletonCircleProps) {
  const { size, sx } = props;

  return <AppSkeletonBlock borderRadius="50%" height={size} sx={sx} width={size} />;
}
